<template>
  <div class="text-center">
    <v-overlay :value="loading" dark>
      <CubeShadow size="70px" background="#e9e9ea"></CubeShadow>

    </v-overlay>
  </div>
</template>





<script>
import {CubeShadow} from 'vue-loading-spinner'
export default {
  props: ["loading"],
  components: {
    CubeShadow
  },
  data: () => ({

  }),



}
</script>

<style scoped>



</style>